<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'bandeiras') {
            next({ name: 'pro-bandeira-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'bandeiras') {
            this.$router.push({ name: 'pro-bandeira-list' });
        }
    },
};
</script>
